import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './paypal_footer.less'
import { getI18n } from 'client/i18n'
import CountryFlag from 'components/common/country_flag'
import { launchOpinionLabSurvey } from 'lib/feedback'

const i18n = getI18n('components/component-header-footer/footer/vx-footer')

const Link = ({ linkUrl, target, text, onClick }) => {
  if (!linkUrl) {
    return null
  }

  return (
    <li>
      <a href={linkUrl} target={target} onClick={onClick}>
        {text}
      </a>
    </li>
  )
}

Link.prototype.propTypes = {
  linkUrl: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
}

class PayPalFooter extends React.Component {
  static propTypes = {
    linksConfig: PropTypes.object,
    userConfig: PropTypes.object,
    groupFeatures: PropTypes.object,
    children: PropTypes.any,
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        code: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    country: PropTypes.string,
    locale: PropTypes.string,
    showLanguageSelection: PropTypes.bool,
  }

  launchOpinionLab = () => {
    launchOpinionLabSurvey(this.props.country, this.props.locale)
  }

  render() {
    const { linksConfig: links, userConfig, groupFeatures } = this.props
    const { shouldShowRewardCardsDisclaimer = false } = groupFeatures

    return (
      <footer styleName="footer" className="vx_globalFooter">
        <div className="vx_globalFooter-content" styleName="footer-content">
          <ul className="vx_globalFooter-list" styleName="primary-links">
            <Link {...links.help} text={i18n('footer.linkHelp')} />
            <Link {...links.security} text={i18n('footer.linkSecurity')} />
          </ul>
          {this.props.showLanguageSelection && (
            <div styleName="language-selector">
              {this.props.languages.map(lang => {
                return (
                  <a
                    styleName="lang"
                    key={lang.code}
                    href={`?locale.x=${lang.code}`}
                  >
                    {lang.name}
                  </a>
                )
              })}
              <a href="/webapps/mpp/country-worldwide">
                <CountryFlag country={this.props.country} />
              </a>
            </div>
          )}
          <div
            className="vx_globalFooter_secondary"
            styleName="secondary-links"
          >
            <p className="vx_globalFooter-copyright">
              <span
                dangerouslySetInnerHTML={{
                  __html: i18n('footer.copyright', {
                    currentYear: new Date().getFullYear(),
                  }),
                }}
              />
              &nbsp;
              {i18n('footer.copyrightText')}
            </p>
            <ul className="vx_globalFooter-list_secondary">
              <Link {...links.imprint} text={i18n('footer.linkImprint')} />
              <Link {...links.privacy} text={i18n('footer.linkPrivacy')} />
              <Link {...links.legal} text={i18n('footer.linkLegal')} />
              <Link
                {...links.policyUpdates}
                text={i18n('footer.policyUpdates')}
              />
              <Link
                linkUrl={`${GLOBAL_CONSTS.REQUEST_URI}/terms`}
                target="_top"
                text={i18n('footer.linkTerms')}
              />
              <Link
                linkUrl="#"
                onClick={this.launchOpinionLab}
                text={i18n('footer.linkFeedback')}
              />
            </ul>
          </div>
          {links.guideAndDisclosure.linkUrl && (
            <p className="footerLink-guideAndDisclosure">
              {/* "Combined Financial Services Guide and Product Disclosure Statement"(AU) */}
              <a
                href={links.guideAndDisclosure.linkUrl}
                target={links.guideAndDisclosure.target}
              >
                {i18n('footer.linkGuideAndDisclosure')}
              </a>
            </p>
          )}

          {userConfig.features.disclaimerLx && (
            <div
              className="footerSmallText vx_globalFooter-disclaimer nemo_disclaimerText"
              dangerouslySetInnerHTML={{
                __html: i18n('footer.disclaimerTextLx'),
              }}
            />
          )}
          {userConfig.features.disclaimerSg && (
            <div
              className="footerSmallText vx_globalFooter-disclaimer nemo_disclaimerText"
              dangerouslySetInnerHTML={{
                __html: i18n('footer.disclaimerTextSg'),
              }}
            />
          )}
          {!userConfig.features.disclaimerLx &&
            !userConfig.features.disclaimerSg && (
              <span>
                <div
                  className="footerSmallText vx_globalFooter-disclaimer nemo_disclaimerText"
                  dangerouslySetInnerHTML={{
                    __html: i18n('footer.disclaimerText')
                      .trim()
                      .replace('&nbsp;', ''),
                  }}
                />
                {shouldShowRewardCardsDisclaimer && (
                  <div
                    className="footerSmallText vx_globalFooter-disclaimer"
                    dangerouslySetInnerHTML={{
                      __html: i18n('disclaimer.rewardCards'),
                    }}
                  />
                )}
              </span>
            )}
        </div>
      </footer>
    )
  }
}

export default cssModules(PayPalFooter, styles)
